var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-user-component',{attrs:{"routeToPostulantsDetails":'admin-postulants-detail',"routeToParticipantsDetails":'admin-participants-detail'}})}
var staticRenderFns = []

export { render, staticRenderFns }